/**完成订单 评价订单**/
<template>
  <div class="lineSelect">
  </div>
</template>

<script>
  import Picker from 'better-picker'

  export default {
    name: 'xk-lineSelect',
    props: ['title', 'data'],
    computed: {},
    data () {
      return {
        state: true,
        city: [],
        address: []
      }
    },
    watch: {
      data: 'addDateFn'
    },
    methods: {
      addDateFn: function (val) { // 数据重组
        let that = this
        that.city = []
        that.address = []
        let Data = that.$props.data
        for (let i = 0; i < Data.length; i++) {
          that.city.push({text: Data[i].city, value: Data[i].city})
          let address = Data[i].address
          let addressObj = []
          for (let j = 0; j < address.length; j++) {
            addressObj.push({
              text: typeof address[j] === 'object' ? (address[j].endAddress || address[j].startAddress) : address[j],
              value: address[j]
            })
          }
          that.address.push(addressObj)
        }

        if (that.city.length > 0) {
          that.showFn(0)
        }
      },
      showFn: function (index) {
        let that = this
        let selectedNum = 0
        if (that.state) {
          that.state = false
          let picker = new Picker({
            data: [that.city, that.address[index]],
            selectedIndex: [0, 1],
            title: that.$props.title
          })
          picker.show()
          setTimeout(() => {
            picker.scrollColumn(0, 0)
            picker.scrollColumn(1, 0)
          }, 0)
          picker.on('picker.change', (index, selectedIndex) => {
            if (index === 0) {
              selectedNum = selectedIndex
              picker.refillColumn(1, that.address[selectedIndex])
            }
          })
          picker.on('picker.select', (selectedVal, selectedIndex) => {
            that.state = true
            that.$emit('click', {
              city: that.city[selectedIndex[0]].value,
              address: that.address[selectedNum][selectedIndex[1]].value
            })
            let body = document.getElementsByTagName('body')[0]
            let pickers = document.getElementsByClassName('picker')
            if (pickers && pickers.length > 0) {
              for (let i = 0; i < pickers.length; i++) {
                body.removeChild(pickers[i])
              }
            }
          })
          picker.on('picker.cancel', () => {
            that.state = true
            let body = document.getElementsByTagName('body')[0]
            let pickers = document.getElementsByClassName('picker')
            if (pickers && pickers.length > 0) {
              for (let i = 0; i < pickers.length; i++) {
                body.removeChild(pickers[i])
              }
            }
            that.$emit('click')
          })
        }
      }
    },
    mounted: function () {
      let that = this
      that.addDateFn()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
</style>



// WEBPACK FOOTER //
// lineSelect.vue?0adecac1